import Vue from 'vue';
import Component from 'vue-class-component';
import './risk-budget-request.scss';
import { Prop } from 'vue-property-decorator';
import { convertToFixedNumberOfDecimals } from '~/utils/math-helper';

@Component({})
export default class RiskBudgetRequestComponent extends Vue {
    private isTotal: boolean = true;

    @Prop()
    private risk: any;
    @Prop()
    private elementIndex: number;

    constructor() {
        super();
    }

    private convertToFixedNumberOfDecimals = (value: number) => convertToFixedNumberOfDecimals(value)

    private emitCopy(index: number) {
        this.$emit('copy', index);
    }
}
